import { useApiClient } from "@/src/hooks/useApiClient";
import { useQueryErrorToast } from "@/src/hooks/useQueryErrorToast";
import { useTranslations } from "@/src/i18n/i18n";
import { ApiError } from "@/src/libs/ApiError";

/**
 * La fiche d'administration d'un compte.
 *
 * Une seule requête pour tout ce qui décrit le compte : son identité, son
 * profil public, ses armées et six compteurs. Les **listes** d'abonnements
 * n'y sont pas — le serveur les laisse à `/profile/favorite-profiles/{id}`,
 * qui existait déjà : la fiche s'ouvre en un appel, et la liste ne se paie
 * qu'au clic.
 */
export function useAdminAccount(accountId: number) {
  const $api = useApiClient();
  const t = useTranslations("accounts");

  const { data, error, isError, isLoading } = $api.useQuery(
    "get",
    "/api/v1/moderation/accounts/{id}",
    { params: { path: { id: accountId } } },
  );

  // Un 404 est un cas normal : l'URL a été tapée à la main, ou le compte a été
  // supprimé depuis. L'écran le dit lui-même ; un toast ferait croire à une
  // panne du serveur.
  const isMissing = ApiError.from(error)?.status === 404;

  useQueryErrorToast(isError, t("detail-error"), error, !isMissing);

  return { detail: data?.data, isLoading, isError, isMissing };
}
